import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    * > svg {
        position: absolute;
        pointer-events: none;
        transform-origin: top left;
        transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
        line-height: 1;
        right: 1rem;
        top: 1rem;
    }
    &:focus-within {
        > label {
            transform: translate(0, 10px) scale(0.75);
            color: ${globalThis.config.colors.black};
        }
    }
`;

export const TextArea = styled.textarea`
    border-radius: ${globalThis.config.sizes.borderRadius};
    border: ${globalThis.config.border.small};
    padding: 1.5rem 1rem 0.5rem 1rem;
    font-size: 1rem;
    line-height: 1;
    outline: none;
    box-shadow: none;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    resize: none;
    &:focus {
        border: ${globalThis.config.border.smallBlack};
    }
    input::-webkit-input-placeholder,
    ::placeholder {
        color: ${globalThis.config.colors.gray2};
        opacity: 1;
        font-size: ${globalThis.config.fonts.sizes.smedium};
        font-family: ${globalThis.config.fonts.families.light};
    }
    ${(props) =>
        props.error &&
        `
        border: solid 0.01rem ${globalThis.config.colors.red1};
        &:focus {
            box-shadow: 0 0 0 0.01rem ${globalThis.config.colors.red1};
        }
    `}
`;

export const InputError = styled.span`
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${globalThis.config.border.white};
    width: 3rem;
    height: 3rem;
    border-radius: 0.3rem;
`;
